// Shared constants
export {
  GlaApiStatus,
  InterfaceStatus,
  CorrespondentType,
  ApiLogStatus,
  DataType,
  GenerationType,
} from "./api-status";

export {
  FX_DATA_TYPE,
  GROUP_BY_TYPE,
  GROUP_BY_TYPES,
  SHEET_NAMES,
  type FxDataType,
  type GroupByType,
} from "./fx-position";

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  DOMAIN_RULE_VIOLATION: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
} as const;

export enum HTTP_STATUS_TEXT {
  Status = "Status",
  Success = "Success",
  Failed = "Failed",
}

export enum ErrorCode {
  // Validation errors
  VALIDATION = "VALIDATION",

  // Authentication & Authorization errors
  UNAUTHORIZED = "UNAUTHORIZED",
  AUTH_FAILED = "AUTH_FAILED",
  FORBIDDEN = "FORBIDDEN",
  SESSION_EXPIRED = "SESSION_EXPIRED",
  LOGGED_IN_ELSEWHERE = "LOGGED_IN_ELSEWHERE",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
  REFRESH_TOKEN_EXPIRED = "REFRESH_TOKEN_EXPIRED",
  INVALID_TOKEN = "INVALID_TOKEN",
  TENANT_NOT_CONNECTED = "TENANT_NOT_CONNECTED",
  MISSING_REFRESH_TOKEN = "MISSING_REFRESH_TOKEN",

  // Resource errors
  NOT_FOUND = "NOT_FOUND",
  CONFLICT = "CONFLICT",

  // Business logic errors
  DOMAIN_RULE_VIOLATION = "DOMAIN_RULE_VIOLATION",
  BUSINESS_RULE_VIOLATION = "BUSINESS_RULE_VIOLATION",

  // Infrastructure errors
  DATABASE_ERROR = "DATABASE_ERROR",
  EXTERNAL_SERVICE_ERROR = "EXTERNAL_SERVICE_ERROR",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",

  // Rate limiting
  RATE_LIMIT_EXCEEDED = "RATE_LIMIT_EXCEEDED",
}

export const BRANCH_COUNT = 11;
